import Vue from 'vue'
import Vuex from 'vuex'
// import page from './store/page'

Vue.use(Vuex)

export default new Vuex.Store({
  // modules: {
  //   page
  // },
  state: {
    page: '',
    pageDialog: false
  },
  mutations: {
    setPage(state, page) {
      state.page = page
    },
    setPageDialog(state, val) {
      state.pageDialog = val
    }
  },
  actions: {
    setPage ({ commit }, page) {
      commit('setPage', page)
    },
    setPageDialog ({ commit }, val) {
      commit('setPageDialog', val)
    }
  },
  getters: {
    getPage: state => {
      return state.page
    },
    getPageDialog: state => {
      return state.pageDialog
    }
  }
})
